export const navData = [
  {
    id: 0,
    text: "Vendors",
    link: "/vendors",
    submenu: {
      "Arab Countries": [
        {
          id: 1,
          name: "Algeria",
          created_at: "2024-03-13T10:37:32.000000Z",
          updated_at: "2024-03-13T10:37:32.000000Z",
        },
        {
          id: 2,
          name: "Bahrain",
          created_at: "2024-03-13T10:37:32.000000Z",
          updated_at: "2024-03-13T10:37:32.000000Z",
        },
        {
          id: 3,
          name: "Egypt",
          created_at: "2024-03-13T10:37:32.000000Z",
          updated_at: "2024-03-13T10:37:32.000000Z",
        },
        {
          id: 4,
          name: "Iraq",
          created_at: "2024-03-13T10:37:32.000000Z",
          updated_at: "2024-03-13T10:37:32.000000Z",
        },
        {
          id: 5,
          name: "Jordan",
          created_at: "2024-03-13T10:37:32.000000Z",
          updated_at: "2024-03-13T10:37:32.000000Z",
        },
        {
          id: 6,
          name: "Kuwait",
          created_at: "2024-03-13T10:37:32.000000Z",
          updated_at: "2024-03-13T10:37:32.000000Z",
        },
        {
          id: 7,
          name: "Lebanon",
          created_at: "2024-03-13T10:37:32.000000Z",
          updated_at: "2024-03-13T10:37:32.000000Z",
        },
        {
          id: 8,
          name: "Morocco",
          created_at: "2024-03-13T10:37:32.000000Z",
          updated_at: "2024-03-13T10:37:32.000000Z",
        },
        {
          id: 9,
          name: "Oman",
          created_at: "2024-03-13T10:37:32.000000Z",
          updated_at: "2024-03-13T10:37:32.000000Z",
        },
        {
          id: 10,
          name: "Palestine",
          created_at: "2024-03-13T10:37:32.000000Z",
          updated_at: "2024-03-13T10:37:32.000000Z",
        },

        {
          id: 11,
          name: "Qatar",
          created_at: "2024-03-13T10:37:32.000000Z",
          updated_at: "2024-03-13T10:37:32.000000Z",
        },
        {
          id: 12,
          name: "Saudi Arabia",
          created_at: "2024-03-13T10:37:32.000000Z",
          updated_at: "2024-03-13T10:37:32.000000Z",
        },
        {
          id: 13,
          name: "Syria",
          created_at: "2024-03-13T10:37:32.000000Z",
          updated_at: "2024-03-13T10:37:32.000000Z",
        },
        {
          id: 14,
          name: "Tunisia",
          created_at: "2024-03-13T10:37:32.000000Z",
          updated_at: "2024-03-13T10:37:32.000000Z",
        },
        {
          id: 15,
          name: "United Arab Emirates",
          created_at: "2024-03-13T10:37:32.000000Z",
          updated_at: "2024-03-13T10:37:32.000000Z",
        },
        {
          id: 16,
          name: "Yemen",
          created_at: "2024-03-13T10:37:32.000000Z",
          updated_at: "2024-03-13T10:37:32.000000Z",
        },
      ],
      InterNational: [
        {
          id: 17,
          name: "Cyprus",
          created_at: "2024-03-13T10:37:32.000000Z",
          updated_at: "2024-03-13T10:37:32.000000Z",
        },
        {
          id: 18,
          name: "France",
          created_at: "2024-03-13T10:37:32.000000Z",
          updated_at: "2024-03-13T10:37:32.000000Z",
        },
        {
          id: 19,
          name: "Greece",
          created_at: "2024-03-13T10:37:32.000000Z",
          updated_at: "2024-03-13T10:37:32.000000Z",
        },
        {
          id: 20,
          name: "Italy",
          created_at: "2024-03-13T10:37:32.000000Z",
          updated_at: "2024-03-13T10:37:32.000000Z",
        },
        {
          id: 21,
          name: "Portugal",
          created_at: "2024-03-13T10:37:32.000000Z",
          updated_at: "2024-03-13T10:37:32.000000Z",
        },
        {
          id: 22,
          name: "Spain",
          created_at: "2024-03-13T10:37:32.000000Z",
          updated_at: "2024-03-13T10:37:32.000000Z",
        },
        {
          id: 23,
          name: "Turkey",
          created_at: "2024-03-13T10:37:32.000000Z",
          updated_at: "2024-03-13T10:37:32.000000Z",
        },
      ],
    },
  },

  {
    id: 2,
    text: "Wedding Packages",
    link: "/wedding/packages",
    submenu: {
      Bahrain: [
        {
          id: 1,
          name: "Manama",
          link: "#",
        },
      ],
      Egypt: [
        {
          id: 1,
          name: "Alexandria",
          link: "#",
        },
        {
          id: 1,
          name: "Hurghada",
          link: "#",
        },
      ],
      Jordan: [
        {
          id: 1,
          name: "Manama",
          link: "#",
        },
      ],
      Qatar: [
        {
          id: 1,
          name: "Doha",
          link: "#",
        },
      ],
      "Saudi Arabia": [
        {
          id: 1,
          name: "Jeddah",
          link: "#",
        },
      ],
      "United Arab Emirates": [
        {
          id: 1,
          name: "Abu Dhabi",
          link: "#",
        },
        {
          id: 1,
          name: "Ajman",
          link: "#",
        },

        {
          id: 1,
          name: "Dubai",
          link: "#",
        },
        {
          id: 1,
          name: "Fujairah",
          link: "#",
        },
        {
          id: 1,
          name: "Ras Al Khaimah",
          link: "#",
        },
        {
          id: 1,
          name: "Sharjah",
          link: "#",
        },
      ],
      Cyprus: [
        {
          id: 1,
          name: "Limassol",
          link: "#",
        },
        {
          id: 1,
          name: "Paphos",
          link: "#",
        },
        {
          id: 1,
          name: "Protoras",
          link: "#",
        },
      ],
      Turkey: [
        {
          id: 1,
          name: "Istanbul",
          link: "#",
        },
      ],
    },
  },
  {
    id: 3,
    text: "Inspiration",
    link: "/inspiration",
    submenu: {
      "": [
        {
          id: 1,
          name: "Bridal Fashion",
          created_at: "2024-03-06T16:05:08.000000Z",
          updated_at: "2024-03-06T16:05:08.000000Z",
        },
        {
          id: 2,
          name: "Wedding Dresses",
          created_at: "2024-03-06T16:05:08.000000Z",
          updated_at: "2024-03-06T16:05:08.000000Z",
        },
        {
          id: 3,
          name: "Wedding Dress Designers",
          created_at: "2024-03-06T16:05:08.000000Z",
          updated_at: "2024-03-06T16:05:08.000000Z",
        },
        {
          id: 4,
          name: "Bridal Jewelry",
          created_at: "2024-03-06T16:05:08.000000Z",
          updated_at: "2024-03-06T16:05:08.000000Z",
        },
        {
          id: 5,
          name: "Engagement & Wedding Rings",
          created_at: "2024-03-06T16:05:08.000000Z",
          updated_at: "2024-03-06T16:05:08.000000Z",
        },
        {
          id: 6,
          name: "Health & Beauty",
          created_at: "2024-03-06T16:05:08.000000Z",
          updated_at: "2024-03-06T16:05:08.000000Z",
        },
        {
          id: 7,
          name: "Bridal Makeup",
          created_at: "2024-03-06T16:05:08.000000Z",
          updated_at: "2024-03-06T16:05:08.000000Z",
        },
        {
          id: 8,
          name: "Bridal Hairstyle",
          created_at: "2024-03-06T16:05:08.000000Z",
          updated_at: "2024-03-06T16:05:08.000000Z",
        },
        {
          id: 9,
          name: "Wedding Planning",
          created_at: "2024-03-06T16:05:08.000000Z",
          updated_at: "2024-03-06T16:05:08.000000Z",
        },
        {
          id: 10,
          name: "Wedding Invitations",
          created_at: "2024-03-06T16:05:08.000000Z",
          updated_at: "2024-03-06T16:05:08.000000Z",
        },
        {
          id: 11,
          name: "Experts Corner",
          created_at: "2024-03-06T16:05:08.000000Z",
          updated_at: "2024-03-06T16:05:08.000000Z",
        },
        {
          id: 12,
          name: "Wedding Design And Decor",
          created_at: "2024-03-06T16:05:08.000000Z",
          updated_at: "2024-03-06T16:05:08.000000Z",
        },
        {
          id: 13,
          name: "Wedding Flowers",
          created_at: "2024-03-06T16:05:08.000000Z",
          updated_at: "2024-03-06T16:05:08.000000Z",
        },
        {
          id: 14,
          name: "Wedding Cakes",
          created_at: "2024-03-06T16:05:08.000000Z",
          updated_at: "2024-03-06T16:05:08.000000Z",
        },
        {
          id: 15,
          name: "Wedding Favors",
          created_at: "2024-03-06T16:05:08.000000Z",
          updated_at: "2024-03-06T16:05:08.000000Z",
        },
        {
          id: 16,
          name: "Wedding Photography",
          created_at: "2024-03-06T16:05:08.000000Z",
          updated_at: "2024-03-06T16:05:08.000000Z",
        },
        {
          id: 17,
          name: "Wedding Guests Etiquette",
          created_at: "2024-03-06T16:05:08.000000Z",
          updated_at: "2024-03-06T16:05:08.000000Z",
        },
        {
          id: 18,
          name: "The Groom",
          created_at: "2024-03-06T16:05:08.000000Z",
          updated_at: "2024-03-06T16:05:08.000000Z",
        },
        {
          id: 19,
          name: "Wedding Gifts And Registries",
          created_at: "2024-03-06T16:05:08.000000Z",
          updated_at: "2024-03-06T16:05:08.000000Z",
        },
        {
          id: 20,
          name: "Honeymoon",
          created_at: "2024-03-06T16:05:08.000000Z",
          updated_at: "2024-03-06T16:05:08.000000Z",
        },
        {
          id: 21,
          name: "Destination Weddings",
          created_at: "2024-03-06T16:05:08.000000Z",
          updated_at: "2024-03-06T16:05:08.000000Z",
        },
        {
          id: 22,
          name: "Wedding News",
          created_at: "2024-03-06T16:05:08.000000Z",
          updated_at: "2024-03-06T16:05:08.000000Z",
        },
        {
          id: 23,
          name: "Film & Photo Shoots",
          created_at: "2024-03-06T16:05:08.000000Z",
          updated_at: "2024-03-06T16:05:08.000000Z",
        },
        {
          id: 24,
          name: "Corporate Events",
          created_at: "2024-03-06T16:05:08.000000Z",
          updated_at: "2024-03-06T16:05:08.000000Z",
        },
        {
          id: 25,
          name: "Parties & Private Dining",
          created_at: "2024-03-06T16:05:08.000000Z",
          updated_at: "2024-03-06T16:05:08.000000Z",
        },
        {
          id: 26,
          name: "Weddings",
          created_at: "2024-03-06T16:05:08.000000Z",
          updated_at: "2024-03-06T16:05:08.000000Z",
        },
        {
          id: 27,
          name: "Meetings & Conferences",
          created_at: "2024-03-06T16:05:08.000000Z",
          updated_at: "2024-03-06T16:05:08.000000Z",
        },
      ],
    },
  },
  // {
  //   id: 4,
  //   text: "Real Weddings",
  //   link: "/real/weddings",
  //   submenu: {
  //     "": [
  //       {
  //         id: 1,
  //         name: "Royal Weddings",
  //         link: "#",
  //       },
  //       {
  //         id: 1,
  //         name: "Celebrity Weddings",
  //         link: "#",
  //       },

  //       {
  //         id: 1,
  //         name: "Real Luxury Weddings",
  //         link: "#",
  //       },
  //       {
  //         id: 1,
  //         name: "Real Weddings",
  //         link: "#",
  //       },
  //       {
  //         id: 1,
  //         name: "Destination Weddings",
  //         link: "#",
  //       },
  //       {
  //         id: 1,
  //         name: "Lebanese Weddings",
  //         link: "#",
  //       },
  //       {
  //         id: 1,
  //         name: "Qatar Weddings",
  //         link: "#",
  //       },
  //       {
  //         id: 1,
  //         name: "UAE Weddings",
  //         link: "#",
  //       },
  //       {
  //         id: 1,
  //         name: "Jordan Weddings",
  //         link: "#",
  //       },
  //       {
  //         id: 1,
  //         name: "Saudi Weddings",
  //         link: "#",
  //       },
  //       {
  //         id: 1,
  //         name: "Egyptian Weddings",
  //         link: "#",
  //       },
  //       {
  //         id: 1,
  //         name: "Bahrain Weddings",
  //         link: "#",
  //       },
  //       {
  //           id: 1,
  //           name: "Indian Weddings",
  //           link: "#",
  //         },
  //     ],
  //   },
  // },
  // {
  //   id: 5,
  //   text: "Songs",
  //   link: "/songs",
  //   submenu: {
  //       "": [
  //         {
  //           id: 1,
  //           name: "All Songs",
  //           link: "#",
  //         },
  //         {
  //           id: 1,
  //           name: "First Dance Songs",
  //           link: "#",
  //         },
  //         {
  //           id: 1,
  //           name: "Wedding Entrance Songs",
  //           link: "#",
  //         },
  //         {
  //           id: 1,
  //           name: "Slideshow Songs",
  //           link: "#",
  //         },
  //         {
  //           id: 1,
  //           name: "Zaffa",
  //           link: "#",
  //         },

  //       ]
  //   }
  // },
  {
    id: 6,
    text: "Business Owners",
    link: "/business/owners",
    submenu: {
      "": [
        {
          id: 1,
          name: "Add Vendor",
          link: "/create_vendor",
        },
        {
          id: 1,
          name: "Marketing Opportunities",
          link: "/advertise",
        },
        {
          id: 1,
          name: "Business Dashboard",
          link: "#",
        },
      ],
    },
  },
  {
    id: 7,
    text: "Get Offers!",
    link: "/getoffers",
  },
];
